import { Component, inject, signal, effect } from '@angular/core';
import { distinctUntilChanged, startWith } from 'rxjs/operators';
import { LocalStorageService } from 'ngx-webstorage';
import { ProfileService } from '../../../shared/services/app/profile.service';
import { SessionService } from '../../../shared/services/app/session.service';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthType } from '../types/auth-type';

const AUTH_TYPE_STORAGE_KEY = 'authType';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
  standalone: false,
})
export class LoginComponent {
  private session = inject(SessionService);
  private profileService = inject(ProfileService);
  private storage = inject(LocalStorageService);
  private router = inject(Router);

  protected readonly AuthType = AuthType;

  /**
   * Название приложения
   */
  appName = environment.appName;

  /**
   * Выбранный способ аутентификации
   */
  selectedAuthType = signal(this.storage.retrieve(AUTH_TYPE_STORAGE_KEY) ?? AuthType.BASIC);

  constructor() {
    if (this.profileService.isLoggedIn()) {
      this.router.navigate(['/']);
      return;
    }

    this.storage
      .observe('accessToken')
      .pipe(
        takeUntilDestroyed(),
        startWith(null),
        distinctUntilChanged((previous) => {
          return previous !== null;
        }),
      )
      .subscribe((accessToken) => {
        if (accessToken) {
          this.router.navigate([this.session.getRedirectURL('/')]);
        }
      });

    effect(() => {
      const selectedAuthType = this.selectedAuthType();
      this.storage.store(AUTH_TYPE_STORAGE_KEY, selectedAuthType);
    });
  }

  setAuthType(type: AuthType) {
    this.selectedAuthType.set(type);
  }
}
